export type PdfLayoutBlockKeys =
  | "header"
  | "team2lock"
  | "metaInfoBlock"
  | "challengeTable"
  | "remainingChallengesBlock"
  | "legendBlock";

const map: { [key in PdfLayoutBlockKeys]: [number, number] } = {
  header: [18, 10],
  team2lock: [18, 30],
  metaInfoBlock: [18, 50],
  challengeTable: [18, 75],
  remainingChallengesBlock: [152, 228],
  legendBlock: [18, 228],
};

export default map;
